<template>
  <div class="grid grid-cols-3 gap-14 w-full px-3 lg:px-0">
    <!-- Section 1: Videos - Full 3 columns -->
    <div class="col-span-3 flex flex-col">
      <h3 class="text-2xl lg:text-4xl text-strongest font-medium mb-6">
        Get to know Phoenix Energy in 5 minutes
      </h3>
      <div class="flex items-center gap-4 overflow-x-scroll no-scrollbar">
        <a
          v-for="video in videoContent"
          :key="video.title"
          :href="video.video_url"
          class="flex flex-col gap-3 flex-1"
        >
          <div class="relative rounded-lg h-[300px] min-w-[160px] overflow-hidden">
            <img :src="video.thumbnail" :alt="video.title" class="w-full h-full object-cover" />
            <div class="absolute inset-0 flex items-center justify-center">
              <div class="w-12 h-12 rounded-full bg-white flex items-center justify-center">
                <svg class="w-5 h-5 ml-0.5" viewBox="0 0 24 24" fill="black">
                  <polygon points="6,3 21,12 6,21" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <h4 class="text-sm font-semibold font-inter text-strongest">
              {{ video.title }}
            </h4>
            <p class="text-sm text-strong font-medium mt-1">
              {{ video.date.toLocaleDateString("en-US", { timeZone: "UTC" }) }}
            </p>
          </div>
        </a>
      </div>
    </div>

    <!-- Section 2: Center Content - 2 columns only -->
    <div class="flex flex-col gap-14 col-span-3 lg:col-span-2 -mx-3 lg:-mx-0">
      <div class="col-span-2 flex flex-col gap-14">
        <div v-for="content in centerContent" :key="content.title">
          <img :src="content.img" alt="News Image" class="w-full object-cover lg:rounded-lg mb-4" />
          <div class="px-3">
            <h2 class="text-base lg:text-2xl font-semibold text-strongest mb-2">
              {{ content.title }}
            </h2>
            <p class="text-sm lg:text-base text-strong font-medium">{{ content.subtext }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 3: Phoenix Fundamentals -->
    <Newsfeed_PhoenixFundamentals>
      <h3
        class="text-2xl lg:text-4xl text-strongest font-medium mb-4 lg:mb-6 leading-none tracking-[-0.64]"
      >
        Phoenix Fundamentals
      </h3>
    </Newsfeed_PhoenixFundamentals>
  </div>
</template>

<script setup>
import Newsfeed_PhoenixFundamentals from "./Newsfeed_PhoenixFundamentals.vue";

import phx_oil from "@/assets/images/newsfeed_oil.png";
import phx_rig from "@/assets/images/newsfeed_rig.png";
import phx_nyc_se from "@/assets/images/newsfeed_nyc_se.png";
import newsfeed_drill from "@/assets/images/adamantium_dark.png";

const videoContent = [
  {
    thumbnail: phx_oil,
    video_url: "#",
    title: "Intro to Phoenix Energy",
    date: new Date("2026-01-15"),
  },
  {
    thumbnail: phx_rig,
    video_url: "#",
    title: "Introducing S1 Offerings",
    date: new Date("2026-01-15"),
  },
  {
    thumbnail: phx_nyc_se,
    video_url: "#",
    title: "Our Journey to the NYSE",
    date: new Date("2026-01-15"),
  },
  {
    thumbnail: newsfeed_drill,
    video_url: "#",
    title: "Drilling Innovations",
    date: new Date("2026-01-15"),
  },
];

const centerContent = [
  {
    img: phx_rig,
    title: "Record 4-Miler!",
    subtext:
      "At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community. At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community.",
  },
  {
    img: phx_oil,
    title: "Take Flight with Phoenix Energy",
    subtext:
      "At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community. At the annual Phoenix Energy 4-Miler, participants raced through the Texan landscape, promoting fitness and community.",
  },
];
</script>
